import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-icons',
  templateUrl: './icons.component.html',
  styleUrls: ['./icons.component.sass']
})
export class IconsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
